import React, { useState } from 'react';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';

const galleryCategories = [
  {
    title: 'Rehab Centers (Merdzavan)',
    image: '/images/gallery-merdzavan.jpg',
    link: 'https://teenchallengearmenia.org/merdzavan-gallery/',
  },
  {
    title: "Children's Ministry",
    image: '/images/gallery-children.jpg',
    link: 'https://teenchallengearmenia.org/children/',
  },
  {
    title: 'Rehab Centers (Hrazdan)',
    image: '/images/gallery-hrazdan.jpg',
    link: null,
  },
];

const allPhotos = [
  '/images/gallery-01.jpg',
  '/images/gallery-02.jpg',
  '/images/gallery-03.jpg',
  '/images/gallery-04.jpg',
  '/images/gallery-05.jpg',
  '/images/gallery-06.jpg',
  '/images/gallery-07.jpg',
  '/images/gallery-08.jpg',
  '/images/gallery-09.jpg',
  '/images/gallery-10.jpg',
  '/images/gallery-11.jpg',
  '/images/gallery-12.jpg',
  '/images/gallery-13.jpg',
  '/images/gallery-14.jpg',
  '/images/gallery-15.jpg',
  '/images/gallery-16.jpg',
  '/images/gallery-17.png',
  '/images/gallery-18.jpg',
  '/images/gallery-19.png',
  '/images/gallery-20.png',
  '/images/gallery-21.jpg',
  '/images/gallery-22.png',
  '/images/gallery-23.jpg',
  '/images/gallery-24.jpg',
];

const Gallery = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <>
      <SEOHead path="/gallery" />
      <PageHeader title="Photo Gallery" breadcrumb="Gallery" />

      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="overline">Our Ministry in Pictures</span>
            <h2>Gallery Categories</h2>
          </div>

          <div className="gallery-categories fade-in" style={{ marginBottom: '60px' }}>
            {galleryCategories.map((cat, i) => (
              <a
                key={i}
                href={cat.link || '#'}
                target={cat.link ? '_blank' : undefined}
                rel={cat.link ? 'noopener noreferrer' : undefined}
                className="gallery-cat-card"
                onClick={!cat.link ? (e) => e.preventDefault() : undefined}
              >
                <img src={cat.image} alt={cat.title} loading="lazy" />
                <div className="overlay">
                  <h3>{cat.title}</h3>
                </div>
              </a>
            ))}
          </div>

          <div className="section-header">
            <span className="overline">Activity Photos</span>
            <h2>Ministry in Action</h2>
          </div>

          <div className="gallery-grid">
            {allPhotos.map((img, i) => (
              <div
                key={i}
                className="gallery-item fade-in"
                onClick={() => setLightbox(img)}
              >
                <img src={img} alt={`Ministry activity ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {lightbox && (
        <div className="lightbox-overlay" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" onClick={() => setLightbox(null)}>✕</button>
          <img src={lightbox} alt="Enlarged view" />
        </div>
      )}
    </>
  );
};

export default Gallery;
